"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var PAYMENT_METHOD_BANK_CARD = 1;
var PAYMENT_METHOD_WMR = 2;
var PAYMENT_METHOD_WMZ = 23;
var PAYMENT_METHOD_YANDEX_MONEY = 5;
var PAYMENT_METHOD_MOBILE = 6;
var PAYMENT_METHOD_QIWI = 13;
var PAYMENT_METHOD_BANK_CARD_PCIDSS = 18;
var PAYMENT_METHOD_SBERBANK_ONLINE = 19;
var PAYMENT_METHOD_APPLE_PAY = 21;
var PAYMENT_METHOD_GOOGLE_PAY = 22;

function getAccountData(providerId, providerAccount) {
  var account = providerAccount !== null && providerAccount !== void 0 ? providerAccount : '"нет данных"';

  switch (providerId) {
    case PAYMENT_METHOD_WMR:
      return "WM ".concat(account);

    case PAYMENT_METHOD_WMZ:
      return "WM ".concat(account);

    case PAYMENT_METHOD_QIWI:
      return "QIWI \u043A\u043E\u0448\u0435\u043B\u0435\u043A ".concat(account);

    case PAYMENT_METHOD_APPLE_PAY:
      return "Apple Pay ".concat(account);

    case PAYMENT_METHOD_MOBILE:
      return "\u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 ".concat(account);

    case PAYMENT_METHOD_GOOGLE_PAY:
      return "Google Pay ".concat(account);

    case PAYMENT_METHOD_BANK_CARD:
      return "\u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043A\u0430\u0440\u0442\u0430 ".concat(account);

    case PAYMENT_METHOD_YANDEX_MONEY:
      return "\u042F\u043D\u0434\u0435\u043A\u0441.\u0414\u0435\u043D\u044C\u0433\u0438 ".concat(account);

    case PAYMENT_METHOD_SBERBANK_ONLINE:
      return "\u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043A\u0430\u0440\u0442\u0430 ".concat(account);

    case PAYMENT_METHOD_BANK_CARD_PCIDSS:
      return "\u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043A\u0430\u0440\u0442\u0430 ".concat(account);

    default:
      return 'Нет данных';
  }
}

function Description(_ref) {
  var transactions = _ref.transactions,
      description = _ref.description,
      paymentMethod = _ref.paymentMethod;

  try {
    var _transactions$, _transaction$provider;

    var transaction = (_transactions$ = transactions === null || transactions === void 0 ? void 0 : transactions[0]) !== null && _transactions$ !== void 0 ? _transactions$ : {};
    var providerData = (_transaction$provider = transaction === null || transaction === void 0 ? void 0 : transaction['providerData']) !== null && _transaction$provider !== void 0 ? _transaction$provider : null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-locator": "payout.description",
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['info']
    }, !!(paymentMethod !== null && paymentMethod !== void 0 && paymentMethod['id']) && (providerData === null || providerData === void 0 ? void 0 : providerData['account']) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      "data-locator": "payout.account"
    }, getAccountData(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod['id'], providerData === null || providerData === void 0 ? void 0 : providerData['account']))), (providerData === null || providerData === void 0 ? void 0 : providerData['rrn']) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      "data-locator": "payout.rrn"
    }, "RRN: ".concat(providerData['rrn'], " ")))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      "data-locator": "payout.description"
    }, description)));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(Description);

exports["default"] = _default;